import { Route, Routes } from 'react-router-dom'
import LandingPage from './LandingPage'
import RegisterPage from './SemaLoginAndRegisterPage'
import SignupSuccess from './SignupSuccess'
import OnboardingPage from './Onboarding'
import UploadDocuments from './Onboarding/UploadDocuments'
import PatientAddress from './Onboarding/PatientAddress'
import WelcomeKitInfoPage from './WelcomeKitInfoPage'
import BlockerPage from './BlockerPage'
import AuthWrapperV2 from '../../AuthWrapperV2'
import DoctorLocation from '../../AnayaCare/Components/DoctorLocation'
import useSetTheme from '../../../hooks/useSetTheme'
import { useEffect } from 'react'
import constants from '../../../constants'

const SemaGlutideRoutes = () => {
  const { applyTheme } = useSetTheme(constants.CARE_PROGRAM_TYPE.GLP)

  useEffect(() => {
    const link = document.createElement('link')
    link.href =
      'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap'
    link.rel = 'stylesheet'

    document.head.appendChild(link)
    const timer = setTimeout(() => {
      applyTheme(constants.CARE_PROGRAM_TYPE.GLP)
    }, 1000)

    return () => {
      document.head.removeChild(link)
      clearTimeout(timer)
    }
  }, [])
  return (
    <Routes>
      <Route path="/" Component={LandingPage} />
      <Route path="welcome-kit" Component={WelcomeKitInfoPage} />
      <Route path="register" Component={RegisterPage} />
      <Route path="success" Component={SignupSuccess} />
      <Route path="blocked" Component={BlockerPage} />
      <Route path="onboarding" Component={AuthWrapperV2(OnboardingPage)} />
      <Route path="documents" Component={AuthWrapperV2(UploadDocuments)} />
      <Route path="address" Component={AuthWrapperV2(PatientAddress)} />
      <Route path="doctor-details" Component={AuthWrapperV2(DoctorLocation)} />
    </Routes>
  )
}

export default SemaGlutideRoutes
